import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import assert from "assert";
import { MenuRenderer } from "../../MenuRenderer/MenuRenderer.mjs";
import { MenuItem } from "../../MenuItem/MenuItem.mjs";
import { Button } from "../../Button/Button.mjs";
const DropdownAction = ({ label, onChange, id, icon, options }) => {
  assert(onChange, "A TextareaAction.Dropdown requires you to pass an onChange function");
  return /* @__PURE__ */ jsx(
    MenuRenderer,
    {
      offsetSpace: "small",
      trigger: (triggerProps) => /* @__PURE__ */ createElement(Button, { ...triggerProps, variant: "transparent", bleed: true, icon, key: id }, label),
      children: options == null ? void 0 : options.map((option, index) => /* @__PURE__ */ jsx(MenuItem, { onClick: () => onChange(option), disabled: option.disabled, children: option.label }, index))
    }
  );
};
export {
  DropdownAction
};
